// extracted by mini-css-extract-plugin
module.exports = {"dataSectionRightClass":"index_dataSectionRightClass__b3Gwh","borderClass":"index_borderClass__Nlt_F","dataTipClass":"index_dataTipClass__7LnnX"};